import React, { useRef, useState } from "react";
import "./_videos.scss";
import {useFetch} from "../../utils/hooks/useFetch";
import {motion} from 'framer-motion';

const VideosPage = () => {

    // const [videos] = useFetch("/JSON/musicVideos.json")

    const [data] = useFetch("JSON/musicMedias.json");
        const [selectedVideo, setSelectedVideo] = useState(null);
        const dialogRef = useRef();
    
        const openDialog = (video) => {
            setSelectedVideo(video);
            dialogRef.current?.showModal();
        }
    
        const closeDialog = () => {
            setSelectedVideo(null);
            dialogRef.current?.close();
        }

    return (
        <motion.div
            initial={{translateY : "100vh"}}
            animate={{translateY : 0, transition: {duration: 0.3} }}
            exit={{translateY: "-100vh", transition: {duration: 0.3} }}
        >
            <div className="videos-title">
                <h2>Vidéos</h2>
                <h3>Composition de musique sur diverses vidéos</h3>
            </div>
            <div className="media-container">
                {data.map((obj, index) => (
                    <button
                        className="video-container"
                        key={index}
                        style={{ aspectRatio: "1.95" }}
                        onClick={() => openDialog(obj)}
                    >
                        <img src={obj.thumbnail} alt={obj.title} className="video-thumbnail" />
                    </button>
                ))}
                {/* {videos.map((obj, index) => (
                    <div className="video-container">
                        <video width="560" height="315" controls>
                            <source src={obj.url} type="video/mp4"/>
                        </video>
                        <h4>{obj.title}</h4>
                    </div>
                ))} */}

                <dialog ref={dialogRef} className="video-dialog" onClick={closeDialog}>
                {selectedVideo && (
                    <iframe
                        width="100%"
                        height="100%"
                        src={selectedVideo.iframe}
                        title={selectedVideo.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    />
                )}
            </dialog>
            </div>
        </motion.div>
    )
}
export default VideosPage;